import { makeResetMutation } from '@utils/reset-store'
import { clonarPayload } from '@modules/ws/utils/clonarPayload'
import { buildInitialState } from './state'

// Mutations
export const SET_ONBOARDING_PROCESSES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.onboardingProcesses.data = payload
    state.onboardingProcesses.lastUpdate = new Date()
  }
}
export const ADD_ONBOARDING_PROCESSES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = clonarPayload(payload)
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.onboardingProcesses.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.onboardingProcesses.data.push(data)
      }
    })
  }
}
export const SET_ONBOARDING_PROCESSES_LOADING = (state, payload) => {
  state.onboardingProcesses.loading = payload
}

export const SET_ACCOUNT_MIGRATIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.accountMigrations.data = payload
    state.accountMigrations.lastUpdate = new Date()
  }
}
export const ADD_ACCOUNT_MIGRATIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = clonarPayload(payload)
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.accountMigrations.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.accountMigrations.data.push(data)
      }
    })
  }
}
export const SET_ACCOUNT_MIGRATIONS_LOADING = (state, payload) => {
  state.accountMigrations.loading = payload
}

export const SET_CUSTODY_TRANSFERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.custodyTransfers.data = payload
    state.custodyTransfers.lastUpdate = new Date()
  }
}
export const ADD_CUSTODY_TRANSFERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = clonarPayload(payload)
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.custodyTransfers.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.custodyTransfers.data.push(data)
      }
    })
  }
}
export const SET_CUSTODY_TRANSFERS_LOADING = (state, payload) => {
  state.custodyTransfers.loading = payload
}

export const SET_AVERAGE_PRICE_REQUESTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.averagePriceRequests.data = payload
    state.averagePriceRequests.lastUpdate = new Date()
  }
}
export const ADD_AVERAGE_PRICE_REQUESTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = clonarPayload(payload)
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.averagePriceRequests.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.averagePriceRequests.data.push(data)
      }
    })
  }
}
export const SET_AVERAGE_PRICE_REQUESTS_LOADING = (state, payload) => {
  state.averagePriceRequests.loading = payload
}

export const SET_FEE_BILLING_BATCHES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.feeBillingBatches.data = payload
    state.feeBillingBatches.lastUpdate = new Date()
  }
}
export const ADD_FEE_BILLING_BATCHES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = clonarPayload(payload)
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.feeBillingBatches.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.feeBillingBatches.data.push(data)
      }
    })
  }
}
export const SET_FEE_BILLING_BATCHES_LOADING = (state, payload) => {
  state.feeBillingBatches.loading = payload
}

export const SET_PROFESSIONALS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.professionals.data = payload
    state.professionals.lastUpdate = new Date()
  }
}
export const ADD_PROFESSIONALS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = clonarPayload(payload)
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.professionals.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.professionals.data.push(data)
      }
    })
  }
}
export const SET_PROFESSIONALS_LOADING = (state, payload) => {
  state.professionals.loading = payload
}

export const SET_CLIENT_SWAPS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.clientSwaps.data = payload
    state.clientSwaps.lastUpdate = new Date()
  }
}
export const ADD_CLIENT_SWAPS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = clonarPayload(payload)
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.clientSwaps.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.clientSwaps.data.push(data)
      }
    })
  }
}
export const SET_CLIENT_SWAPS_LOADING = (state, payload) => {
  state.clientSwaps.loading = payload
}

// RESET: restaura o state inicial. Os 7 processos de backoffice carregam
// dados de clientes do escritório — precisam sair da memória junto com o
// módulo `ws` ao trocar de perfil in-SPA. [CU-86ajnmt4r]
export const RESET = makeResetMutation(buildInitialState)

